var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250.29 206.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#007aff;stroke-miterlimit:10;stroke-width:12px;}.cls-2{font-size:164.41px;fill:#006aea;font-family:ArialRoundedMTBold, Arial Rounded MT Bold;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.61,188.5c-8.14,13.65-25.23,12.12-113.29,11.15C34.18,198.62,17,199.93,9.2,186c-11.56-20.72,9.62-53.95,40.56-102.49C82,33,98.68,6.75,123.71,6c29.68-.87,51.6,34.66,81.12,82.49C230.91,130.78,253.35,167.14,240.61,188.5Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(102.32 168.01) scale(0.94 1)"
  }, "!")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.facc80f1c407353fc0cbed3328f0ebf1.svg";
export { ForwardRef as ReactComponent };